import React, { useEffect, useState } from "react";
import Drawer from "..";
import { useSelector } from "react-redux";
import { format } from "date-fns";

import * as APINps from "../../../services/nps/functions";
import Typography from "../../Typography";
import SliderComp from "../../SliderComp";
import SelectTag from "../../SelectTag/SelectTag";
import FieldContainer from "../../FieldContainer/FieldContainer";
import MicroInputIncreaseDecrease from "../../MicroInputIncreaseDecrease/MicroInputIncreaseDecrease";
import DatePicker from "../../DatePicker";
import Loading from "../../Loading";
import InputArea from "../../InputArea";

import "./generate-pdf.css";

const GeneratePdf = ({
  title = "Crie seu relatório personalizado",
  handleClick,
  buttonTitle,
  setUnits,
  initialNpsGoal,
  ...others
}) => {
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const userInfo = useSelector((state) => state.informationusers);
  const [unitsSelected, setUnitsSelected] = useState(filtersDashboard.units);
  const [initialDate, setInitialDate] = useState(
    new Date(filtersDashboard.datestart),
  );
  const [finalDate, setFinalDate] = useState(
    new Date(filtersDashboard.dateend),
  );
  const [businessSelected, setBusinessSelected] = useState([]);
  const [periodNpsSelected, setPeriodNpsSelected] = useState([
    { id: 6, label: "Últimos 6 meses" },
  ]);
  const [npsProfileSelected, setNpsProfileSelected] = useState([
    { id: "DETRATOR", label: "Detratores" },
  ]);
  const [subqualifierSelected, setSubqualifierSelected] = useState([]);
  const [mediumTermSelected, setMediumTermSelected] = useState("24");
  const [caseTypeSelected, setCaseTypeSelected] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [businessList, setBusinessList] = useState([]);
  const [adhesionGoal, setAdhesionGoal] = useState(100);
  const [npsGoal, setNpsGoal] = useState(initialNpsGoal);
  const [csatAndNpsMonths, setCsatAndNpsMonths] = useState("6");
  const [listCases, setListCases] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [tokenIngDesk, setTokenIngDesk] = useState(null);
  const [listSubqualifiers, setListSubqualifiers] = useState([]);
  const [orderSelected, setOrderSelected] = useState([
    { id: "totalOfCases", label: "Quantidade" },
  ]);

  const listRequest = [
    { id: 6, label: "Últimos 6 meses" },
    { id: 5, label: "Últimos 5 meses" },
    { id: 4, label: "Últimos 4 meses" },
    { id: 3, label: "Últimos 3 meses" },
    { id: 2, label: "Últimos 2 meses" },
  ];

  const listOrderOfCases = [
    { id: "openedCases", label: "Abertos" },
    { id: "name", label: "Alfabética" },
    { id: "completedCases", label: "Concluídos" },
    { id: "outOfSlaCases", label: "Estouraram o sla" },
    { id: "percentage", label: "Porcentagem de concluídos" },
    { id: "totalOfCases", label: "Quantidade" },
  ];

  const listNpsProfile = [
    { id: "PROMOTOR", label: "Promotores" },
    { id: "NEUTRO", label: "Neutros" },
    { id: "DETRATOR", label: "Detratores" },
  ];

  /*
      const listSubqualifiers = [
        { id: 1, label: "Atendimento" },
        { id: 2, label: "Estrutura" },
        { id: 3, label: "Serviço" },
      ];
      */

  /*
      const listCases = [
        { id: 1, label: "Reclamação" },
        { id: 2, label: "opt2" },
        { id: 3, label: "opt3" },
      ];
      */

  const listMediumTerm = [
    { id: 24, label: "24 Horas" },
    { id: 48, label: "48 Horas" },
    { id: 72, label: "72 Horas" },
  ];

  const arrayRemove = (arr, value) => {
    return arr.filter(function (elem) {
      return elem.id != value;
    });
  };

  const removeOptionBusiness = (idRemoved) => {
    let elements = arrayRemove(businessSelected, idRemoved);
    setBusinessSelected(elements);
  };

  const removeOptionNpsProfile = (idRemoved) => {
    let elements = arrayRemove(npsProfileSelected, idRemoved);
    setNpsProfileSelected(elements);
  };

  const changeOptionsBusiness = (option) => {
    const arrayFound = businessSelected.find(
      (element) => element.id === option.id,
    );
    if (arrayFound) {
      removeOptionBusiness(arrayFound.id);
    } else {
      setBusinessSelected([
        ...businessSelected,
        { id: option.id, name: option.label },
      ]);
    }
  };

  async function getUnitsList() {
    const response = await APINps.getUnits();

    if (response.status === 200) {
      let dataUpdated = [];

      response.data.forEach((datum) => {
        let requestItem = {};

        requestItem.id = datum.id;
        requestItem.label = datum.description;

        dataUpdated.push(requestItem);
      });
      setUnitsList(dataUpdated);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
    }
  }

  const removeOptionUnits = (idRemoved) => {
    let elements = arrayRemove(unitsSelected, idRemoved);
    setUnitsSelected(elements);
    const hasElements = elements && elements.length;
    if (hasElements) {
      setUnits(elements.map((element) => element.label).join(", "));
    } else {
      setUnits("Todas");
    }
  };

  const changeOptionsUnits = (option) => {
    const arrayFound = unitsSelected.find(
      (element) => element.id === option.id,
    );
    if (arrayFound) {
      removeOptionUnits(arrayFound.id);
    } else {
      const elements = [
        ...unitsSelected,
        { id: option.id, label: option.label },
      ];
      setUnitsSelected(elements);
      const hasElements = elements && elements.length;
      if (hasElements) {
        setUnits(elements.map((element) => element.label).join(", "));
      } else {
        setUnits("Todas");
      }
    }
  };

  async function getBusinessList() {
    const response = await APINps.getBusiness();

    if (response.status === 200) {
      let dataUpdated = [];

      response.data.forEach((datum) => {
        let requestItem = {};

        requestItem.id = datum.id;
        requestItem.label = datum.description;

        dataUpdated.push(requestItem);
      });
      setBusinessList(dataUpdated);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
    }
  }

  const changeOptionsNpsEvolution = (option) => {
    setPeriodNpsSelected([{ id: option.id, label: option.label }]);
  };

  const changeOptionsNpsProfile = (option) => {
    const arrayFound = npsProfileSelected.find(
      (element) => element.id === option.id,
    );
    if (arrayFound) {
      removeOptionNpsProfile(arrayFound.id);
    } else {
      setNpsProfileSelected([
        ...npsProfileSelected,
        { id: option.id, label: option.label },
      ]);
    }
  };

  const changeOptionsSubqualifier = (option) => {
    setSubqualifierSelected([{ id: option.id, label: option.label }]);
  };

  const changeOptionsCaseType = (option) => {
    setCaseTypeSelected([{ id: option.id, label: option.label }]);
  };

  const changeOptionsOrderOfCases = (option) => {
    setOrderSelected([{ id: option.id, label: option.label }]);
  };

  async function getSubqualifiersOptions(dateStart, dateEnd) {
    let updatedListSubqualifiers = [];
    const response = await APINps.indicatorsGeneral(
      dateStart,
      dateEnd,
      "",
      "",
      "",
      "",
      "",
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        updatedListSubqualifiers = data.map((datum) => {
          return {
            id: datum.id_pergunta,
            label: datum.pergunta,
          };
        });
      }
    }
    const hasOptions =
      !!updatedListSubqualifiers && updatedListSubqualifiers.length > 0;
    if (hasOptions) {
      setSubqualifierSelected([updatedListSubqualifiers[0]]);
    } else {
      setSubqualifierSelected([]);
    }

    setListSubqualifiers(updatedListSubqualifiers);
  }

  async function getSolicitations(token) {
    let updatedListCases = [];
    const response = await APINps.getSolicitationsList(token);
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        updatedListCases = data.map((datum) => {
          return {
            id: datum.id_solicitacao,
            label: datum.descricao_solicitacao,
          };
        });
        setCaseTypeSelected([updatedListCases[0]]);
      }
    }

    setListCases(updatedListCases);
  }

  useEffect(() => {
    async function getAllFiltersData() {
      setIsLoading(true);
      const formatedInitialDate = initialDate
        ? format(new Date(initialDate), "yyyy-MM-dd")
        : "";
      const formatedFinalDate = finalDate
        ? format(new Date(finalDate), "yyyy-MM-dd")
        : "";

      const updatedTokenIngDesk = await APINps.getTokenIngDesk(
        userInfo.username,
      );
      setTokenIngDesk(updatedTokenIngDesk);
      await getUnitsList();
      await getBusinessList();
      await getSolicitations(updatedTokenIngDesk);
      await getSubqualifiersOptions(formatedInitialDate, formatedFinalDate);

      setIsLoading(false);
    }

    getAllFiltersData();
  }, []);

  useEffect(() => {
    if (filtersDashboard && filtersDashboard.units) {
      setUnitsSelected(filtersDashboard.units);
    }
    if (filtersDashboard && filtersDashboard.datestart) {
      setInitialDate(new Date(filtersDashboard.datestart));
    }
    if (filtersDashboard && filtersDashboard.dateend) {
      setFinalDate(new Date(filtersDashboard.dateend));
    }
  }, [filtersDashboard]);

  useEffect(() => {
    const updateSubqualifiersOptions = async (initialDate, finalDate) => {
      setIsLoading(true);
      const formatedInitialDate = initialDate
        ? format(new Date(initialDate), "yyyy-MM-dd")
        : "";
      const formatedFinalDate = finalDate
        ? format(new Date(finalDate), "yyyy-MM-dd")
        : "";
      await getSubqualifiersOptions(formatedInitialDate, formatedFinalDate);
      setIsLoading(false);
    };

    updateSubqualifiersOptions(initialDate, finalDate);
  }, [initialDate, finalDate]);

  useEffect(() => {
    setNpsGoal(initialNpsGoal);
  }, [initialNpsGoal]);

  return (
    <Drawer.Main
      id="drawer-pdf-quality"
      title={title}
      isOpen={others.isOpen}
      onClose={() => others.onClose(false)}
      className="dashboard-height"
    >
      <div className="drawerPdf__container drawerPdf-generate-pdf-settings">
        {isLoading ? (
          <div>
            <Loading.Paperplane />
          </div>
        ) : (
          <div>
            <div className="drawerPdf-generate-pdf-settings--holder">
              <div className="drawerPdf-generate-pdf-settings__text-container">
                <p className="drawerPdf-generate-pdf-settings__text-container__text-item">
                  Escolha as informações que deseja incluir no seu relatório
                  para obter uma versão personalizada e sob medida para suas
                  necessidades.
                  <br />
                  <br />
                  Clique em "Exportar relatório" para criar seu relatório
                  personalizado.
                </p>
              </div>
              <FieldContainer
                title="Unidades"
                htmlFor=""
                className="drawerPdf-generate-pdf-settings__units drawerPdf-generate-pdf-settings--text drawerPdf-generate-pdf-settings--mult-select-text"
              >
                <div className="filters-dashboard-container-tag">
                  <SelectTag
                    valueTag={unitsSelected}
                    options={unitsList}
                    placeholder="Todas"
                    multiple={true}
                    onSelect={(option) => {
                      changeOptionsUnits(option);
                    }}
                  />
                </div>
              </FieldContainer>

              <div className="drawerPdf__generate-pdf-settings__date">
                <FieldContainer
                  title="Data início"
                  className="case-client drawerPdf-generate-pdf-settings--text"
                  htmlFor=""
                >
                  <DatePicker.DateRange
                    selected={initialDate}
                    setDate={(event) => {
                      const newDate = event;
                      setInitialDate(newDate);
                    }}
                    selectRangeType="start"
                    endDate={finalDate}
                    maxDate={finalDate}
                    dateFormat={"dd/MM/yyyy"}
                    showYearPicker={false}
                  />
                </FieldContainer>
              </div>
              <div className="drawerPdf__generate-pdf-settings__date">
                <FieldContainer
                  title="Data fim"
                  className="case-client drawerPdf-generate-pdf-settings--text"
                  htmlFor=""
                >
                  <DatePicker.DateRange
                    selected={finalDate}
                    setDate={(event) => {
                      const newDate = event;
                      setFinalDate(newDate);
                    }}
                    selectRangeType="end"
                    startDate={initialDate}
                    minDate={initialDate}
                    dateFormat={"dd/MM/yyyy"}
                    isClearable={false}
                    showYearPicker={false}
                  />
                </FieldContainer>
              </div>
              <div className="drawerPdf-generate-pdf-settings__slider-item">
                <SliderComp
                  value={npsGoal}
                  setValue={setNpsGoal}
                  className="drawerPdf-generate-pdf-settings__slider-item__comp"
                  text="Meta de NPS"
                />
              </div>
              <div className="drawerPdf-generate-pdf-settings__double-column-filters">
                <FieldContainer
                  className="drawerPdf-generate-pdf-settings__filters__item drawerPdf-generate-pdf-settings--text"
                  title="Evolução do NPS e CSAT em meses:"
                  htmlFor=""
                >
                  <MicroInputIncreaseDecrease
                    value={csatAndNpsMonths}
                    onChangeValue={(value) => {
                      setCsatAndNpsMonths(value);
                    }}
                  />
                  {/*<div className="filters-dashboard-container-tag">
                  <SelectTag
                    valueTag={periodNpsSelected}
                    options={listRequest}
                    onSelect={(option) => {
                      changeOptionsNpsEvolution(option);
                    }}
                    multiple={false}
                  />
                </div>*/}
                </FieldContainer>
              </div>
              <div className="drawerPdf-generate-pdf-settings__double-column-filters">
                <FieldContainer
                  className="drawerPdf-generate-pdf-settings__filters__item drawerPdf-generate-pdf-settings--text drawerPdf-generate-pdf-settings__double-column-filters--single-select"
                  title="Detalhar casos do tipo:"
                  htmlFor=""
                >
                  <div className="filters-dashboard-container-tag">
                    <SelectTag
                      valueTag={caseTypeSelected}
                      options={listCases}
                      onSelect={(option) => {
                        changeOptionsCaseType(option);
                      }}
                      multiple={false}
                    />
                  </div>
                </FieldContainer>
              </div>
              <div className="drawerPdf-generate-pdf-settings__filters">
                <FieldContainer
                  className="drawerPdf-generate-pdf-settings__filters__item drawerPdf-generate-pdf-settings__filters--single-select"
                  title="Ordenar casos por:"
                  htmlFor=""
                >
                  <div className="filters-dashboard-container-tag">
                    <SelectTag
                      valueTag={orderSelected}
                      options={listOrderOfCases}
                      onSelect={(option) => {
                        changeOptionsOrderOfCases(option);
                      }}
                      multiple={false}
                    />
                  </div>
                </FieldContainer>
              </div>
              <div className="drawerPdf-generate-pdf-settings__filters">
                <FieldContainer
                  className="drawerPdf-generate-pdf-settings__filters__item"
                  title="Perfil de tratativas"
                  htmlFor=""
                >
                  <div className="filters-dashboard-container-tag">
                    <SelectTag
                      valueTag={npsProfileSelected}
                      options={listNpsProfile}
                      placeholder="Todos"
                      onSelect={(option) => {
                        changeOptionsNpsProfile(option);
                      }}
                      multiple={true}
                      isCloseOnSelect={false}
                    />
                  </div>
                </FieldContainer>
              </div>
              <div className="drawerPdf-generate-pdf-settings__slider-item">
                <SliderComp
                  value={adhesionGoal}
                  setValue={setAdhesionGoal}
                  className="drawerPdf-generate-pdf-settings__slider-item__comp"
                  text="Meta de adesão"
                />
              </div>
              <div className="drawerPdf-generate-pdf-settings__double-column-filters">
                <FieldContainer
                  className="drawerPdf-generate-pdf-settings__filters__item drawerPdf-generate-pdf-settings--text drawerPdf-generate-pdf-settings__double-column-filters--single-select"
                  title="Ranking de Subqualificadores"
                  htmlFor=""
                >
                  <div className="filters-dashboard-container-tag">
                    <SelectTag
                      valueTag={subqualifierSelected}
                      options={listSubqualifiers}
                      onSelect={(option) => {
                        changeOptionsSubqualifier(option);
                      }}
                      multiple={false}
                    />
                  </div>
                </FieldContainer>
              </div>
              <div className="drawerPdf-generate-pdf-settings__double-column-filters">
                <FieldContainer
                  title="Prazo médio de tratativas ideal"
                  className="drawerPdf-generate-pdf-settings--text"
                  htmlFor=""
                >
                  <div className="filters-dashboard-container-tag">
                    <InputArea
                      value={mediumTermSelected}
                      setValue={setMediumTermSelected}
                    />
                  </div>
                </FieldContainer>
              </div>

              {/*         
          <FieldContainer title="Negócio" htmlFor="">
            <div className="filters-dashboard-container-tag">
              <SelectTag
                valueTag={businessSelected}
                options={businessList}
                onSelect={(option) => {
                  changeOptionsBusiness(option);
                }}
              />
            </div>
          </FieldContainer> */}
              <div className="drawerPdf__generate-pdf-settings__btn drawerPdf-generate-pdf-settings__buttons">
                <button
                  type="button"
                  className="drawerPdf-generate-pdf-settings__buttons__cancel"
                  onClick={() => {
                    others.onClose(false);
                  }}
                >
                  <Typography.H4 color={"red-2"}>Cancelar</Typography.H4>
                </button>
                <button
                  type="button"
                  onClick={() => {
                    const periodSelected = [
                      {
                        id: Number(csatAndNpsMonths)
                          ? Number(csatAndNpsMonths)
                          : 0,
                        label: `Últimos ${
                          Number(csatAndNpsMonths)
                            ? Number(csatAndNpsMonths)
                            : 0
                        } meses`,
                      },
                    ];

                    let updatedNpsProfiles = npsProfileSelected;
                    const hasMultiplesProfiles =
                      !!npsProfileSelected && npsProfileSelected.length > 0;
                    if (hasMultiplesProfiles) {
                      const idsArr = npsProfileSelected.map((profile) => {
                        return profile.id;
                      });

                      const id = idsArr.join(",");

                      const labelsArr = npsProfileSelected.map((profile) => {
                        return profile.label;
                      });

                      const label = labelsArr.join(", ");

                      updatedNpsProfiles = [
                        {
                          id,
                          label,
                        },
                      ];
                    } else {
                      updatedNpsProfiles = [
                        {
                          id: "PROMOTOR,NEUTRO,DETRATOR",
                          label: "Promotores, Neutros, Detratores",
                        },
                      ];
                    }
                    let updatedMediumTermSelect = [{ id: 0, label: "0 Horas" }];
                    const isMediumTermANumber =
                      !!Number(mediumTermSelected) ||
                      Number(mediumTermSelected) === 0;
                    if (isMediumTermANumber) {
                      const id = Number(mediumTermSelected);
                      const label = mediumTermSelected + " Horas";
                      updatedMediumTermSelect = [
                        {
                          id,
                          label,
                        },
                      ];
                    }

                    handleClick(
                      updatedNpsProfiles,
                      subqualifierSelected,
                      caseTypeSelected,
                      periodSelected,
                      unitsSelected,
                      initialDate,
                      finalDate,
                      npsGoal,
                      adhesionGoal,
                      updatedMediumTermSelect,
                      tokenIngDesk,
                      orderSelected,
                    );
                  }}
                  className="drawerPdf__content__form__group__button"
                >
                  <Typography.H5 color={"white"} weight={700}>
                    {buttonTitle}
                  </Typography.H5>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Drawer.Main>
  );
};

export default GeneratePdf;
